interface ContextErrorStateProps {
    title?: string;
    message?: string;
    onReturn?: () => void;
    returnLabel?: string;
}

export function ContextErrorState({
    title = 'Context Not Available',
    message = "We couldn't find outline data for this passage. This may be because the outline hasn't been generated yet.",
    onReturn,
    returnLabel = 'Return to Reading'
}: ContextErrorStateProps) {
    return (
        <div className="flex items-center justify-center h-screen bg-gradient-to-br from-gray-900 to-gray-800">
            <div className="text-center space-y-4 max-w-md px-6">
                <div className="text-red-400 text-5xl">⚠️</div>
                <h2 className="text-white text-2xl font-bold">{title}</h2>
                <p className="text-white/70">{message}</p>
                {onReturn && (
                    <button
                        onClick={onReturn}
                        className="mt-6 px-6 py-3 bg-white/10 hover:bg-white/20 border border-white/20 rounded-lg text-white transition-colors"
                    >
                        {returnLabel}
                    </button>
                )}
            </div>
        </div>
    );
}

